module.exports = __webpack_public_path__ + "media/Join.b0efd4d3.mp3";